export const ROUTE_DASHBOARD = "/teacher/dashboard";
export const ROUTE_TEST_CREATION = "/teacher/test-creation";
export const ROUTE_TEST_MANAGEMENT = "/teacher/test-management";
export const ROUTE_STUDENT_PERFORMANCE = "/teacher/student-performance";
export const ROUTE_STUDENT_LEADERBOARD = "/teacher/student-leaderboard";
export const ROUTE_TEACHER_QUIZ = "/teacher/admin-quiz";
export const ROUTE_QUESTION_PAPERS = "/teacher/question-papers";
export const ROUTE_QUESTION_BANK = "/teacher/question-papers";
export const ROUTE_QUESTION_BANK_VIEW = "/teacher/question-bank-view";
export const ROUTE_KNOWLEDGE_BASE = "/teacher/knowledge-base";
export const ROUTE_ADMIN_QUIZ_ROOM = "/teacher/admin-async-quiz-room";
export const ROUTE_ADMIN_LIVE_QUIZ_ROOM = "/teacher/admin-live-room";
export const ROUTE_ADMIN_LEADER_BOARD="teacher/admin-leader-board";
export const ROUTE_CLASSROOM_QUIZ_SUMMARY = "/teacher/360-analysis";
